import { render, staticRenderFns } from "./2.Method.vue?vue&type=template&id=761f2fac&scoped=true&"
import script from "./2.Method.vue?vue&type=script&lang=js&"
export * from "./2.Method.vue?vue&type=script&lang=js&"
import style0 from "./2.Method.vue?vue&type=style&index=0&id=761f2fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761f2fac",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideYReverseTransition})


/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('761f2fac')) {
      api.createRecord('761f2fac', component.options)
    } else {
      api.reload('761f2fac', component.options)
    }
    module.hot.accept("./2.Method.vue?vue&type=template&id=761f2fac&scoped=true&", function () {
      api.rerender('761f2fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/訂單流程/2.Method.vue"
export default component.exports